import {
  copyFiles,
  downloadFile,
  getFilesV2,
  moveFiles,
  removeFile,
  renameFile,
  shareFiles,
  unshareFiles,
  uploadFile,
} from '../_requests'
import {FileStore, OWN_ROOT} from './types'

/**
 * My Files: the storage calls the Files browser has always made, behind {@link FileStore}.
 *
 * Paths are relative to `<identityId>/`. Amplify's `private` level with an empty custom prefix
 * (download, upload, folder, delete) already resolves them there; the REST calls (list, rename,
 * move, copy, public links) are sent the full key, which is added here, in the exact form the
 * browser used to build itself.
 */
export function createOwnStore(identityId: string): FileStore {
  /** A destination folder as the move and copy endpoints take it: `<id>/` or `<id>/a/b/`. */
  const folderKey = (folder: string) => `${identityId}/${folder === '' ? '' : `${folder}/`}`

  return {
    root: OWN_ROOT,
    list: (folder) => getFilesV2(`${identityId}/${folder}`),
    download: (path, asBlob) => downloadFile(path, asBlob),
    upload: (path, file) => uploadFile(path, file),
    // No file: uploadFile writes the `<path>/` folder marker.
    createFolder: (path) => uploadFile(path),
    remove: (path) => removeFile(path),
    rename: (source, destination) =>
      renameFile({source, destination: `${identityId}/${destination}`}, identityId),
    move: (sources, destinationFolder) =>
      moveFiles({source: sources, destination: folderKey(destinationFolder)}, identityId),
    copy: (sources, destinationFolder) =>
      copyFiles({source: sources, destination: folderKey(destinationFolder)}, identityId),
    createPublicLinks: (paths) => shareFiles(paths, identityId),
    removePublicLinks: (paths) => unshareFiles(paths, identityId),
  }
}
